module.exports = __webpack_public_path__ + "static/media/SF-UI-Text-Light.50c49288.woff";